import { render, staticRenderFns } from "./QuestionGroupList.vue?vue&type=template&id=48bc4afc&scoped=true&"
import script from "./QuestionGroupList.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc4afc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VDivider,VSubheader})
